/**
 * Determine whether it's a mobile phone or tablet. Often used for determining whether we need auto-focus on inputs.
 * WARNING: DO NOT use this for determining whether to show/hide elements or change the layout. We have better methods for that.
 */
export function isTouchDevice(): boolean {
  return "ontouchstart" in document.documentElement && window.innerWidth < 1024;
}
